import { useSendInvoiceToValidation } from "../../../graphql/hooks/invoices/useSendInvoiceToValidation";
import { theme } from "../../../theme";
import { useTranslation } from "react-i18next";
import TextButton from "../../atoms/buttons/TextButton";
import { ReturnIcon } from "../../atoms/icons/ReturnIcon";
import { useState } from "react";
import Alert from "../Alert";

interface Props {
  invoiceId: string;
  variant: "textButton";
  disabled?: boolean;
  onSuccess?: () => void;
}

const SendInvoiceBackToValidationButton = ({
  invoiceId,
  variant,
  onSuccess,
  disabled,
}: Props) => {
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState("");

  const onCompletedReturnToValidation = (res?: any) => {
    if (res?.invoice?.sendInvoiceToValidation?.success) {
      setErrorMessage("");
      if (onSuccess) {
        onSuccess();
      }
    } else {
      setErrorMessage(t("errors.couldNotReturnInvoiceToValidation"));
    }
  };
  const onErrorReturnToValidation = (error?: any) => {
    setErrorMessage(
      error?.message || t("errors.couldNotReturnInvoiceToValidation"),
    );
  };

  const { sendInvoiceToValidation, error, loading } =
    useSendInvoiceToValidation({
      onCompleted: onCompletedReturnToValidation,
      onError: onErrorReturnToValidation,
    });

  const onClickReturnToValidation = async () => {
    try {
      await sendInvoiceToValidation({
        variables: {
          input: {
            invoiceId: invoiceId,
          },
        },
      });
    } catch (error) {
      setErrorMessage(
        error?.toString() || t("errors.couldNotReturnInvoiceToValidation"),
      );
    }
  };

  return (
    <div>
      {variant === "textButton" && (
        <TextButton
          title={t("invoiceAssessment.sendInvoiceBackToValidation")}
          onClick={onClickReturnToValidation}
          color={theme.colors.textSecondary}
          icon={<ReturnIcon color={theme.colors.textSecondary} />}
          iconPosition="right"
          loading={loading}
          disabled={disabled}
        />
      )}
      {error && (
        <Alert
          type="error"
          message={errorMessage}
          title={t("errors.couldNotReturnInvoiceToValidation")}
          version="snackbar"
          onClickClose={() => setErrorMessage("")}
        />
      )}
    </div>
  );
};

export default SendInvoiceBackToValidationButton;
